module.exports = __webpack_public_path__ + "img/calco2ai-flight-icon.f957acd2.png";